import { Account } from '../../../types';
import { callExternalApi } from '../../callExternalApi';

export interface AccountSearchPage {
  data: Account[];
  // How many accounts matched the query in total; `data` is capped by the API's search limit.
  totalMatches: number;
}

export const searchAccounts = async (query: string) => {
  return await callExternalApi<AccountSearchPage>({
    url: `api/admin/search_accounts?query=${encodeURIComponent(query)}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};
